import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { MarketingContent } from './marketing-content.model';
import { MarketingContentService } from './marketing-content.service';

@Component({
  selector: 'capq-marketing-content',
  templateUrl: './marketing-content.component.html',
  styleUrls: ['./marketing-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarketingContentComponent implements OnInit {
  marketingContent$!: Observable<MarketingContent | null>;
  showMarketingContent$!: Observable<boolean>;

  constructor(readonly marketingContentService: MarketingContentService) {}

  ngOnInit(): void {
    this.marketingContent$ = this.marketingContentService.getMarketingContent();
    this.showMarketingContent$ =
      this.marketingContentService.showMarketingContent$;
  }
}
